import { AxiosError } from 'axios';
import { GET_GROUP_EXAM_REGISTRATION_SUMMARY_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GROUP_EXAM_REGISTRATION_SUMMARY_QUERY_KEY } from '../../constants/queryKeys';
import { ExamRegistrationType, ExamType } from '../../api/candidate/exam/model';
import { FileProcessingState } from '../../models/File';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GroupRegistrationSummaryResponse {
  uuid: string;
  examType: {
    code: ExamType;
    description: string;
  };
  lastUpdatedTime: string;
  examRegistrationType: ExamRegistrationType;
  fileUuid: string;
  fileStatus: FileProcessingState;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: GroupRegistrationSummaryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  refetchInterval: number | undefined;
  isRedirect?: boolean;
}

export const useGetGroupRegistrationSummary = ({
  uuid,
  enabled = true,
  onSuccess,
  onError,
  refetchInterval,
  isRedirect = true,
}: Input) => {
  const getGroupRegistrationSummary = async () => {
    const res = await axiosClient.get<GroupRegistrationSummaryResponse>(
      GET_GROUP_EXAM_REGISTRATION_SUMMARY_URL(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_GROUP_EXAM_REGISTRATION_SUMMARY_QUERY_KEY, uuid],
    getGroupRegistrationSummary,
    {
      onSuccess,
      onError,
      retryOnMount: true,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      refetchInterval,
      enabled,
    },
    false,
    isRedirect
  );
};
